var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { patch } from 'incremental-dom';
import { addPolyfills } from './polyfills';
import { packageVersion } from './version';
import { pageChangeSubject } from './rxjs';
import { map, share } from 'rxjs/operators';
import { ImageBanner } from './common/imageBanner/imageBanner';
import { cookie } from './common/cookieWarning';
import { createElement } from './incdom';
import { getStorePix } from './pixList';
import './normalise.scss';
import './main.scss';
import './standardPage.scss';
export var exportedSiteData;
// Only needed for karma tests where initApp is not called.
export var setSiteData = function (siteData) {
    exportedSiteData = __assign({}, siteData);
};
var errorPage = function (pco) {
    createElement("render", null,
        createElement("h2", null, "Error Handler Test"),
        createElement("p", null, "This page is for test only"));
    setTimeout(function () {
        throw (new Error("Test Error"));
    }, 1000);
};
var initApp = function (pageList, siteData) {
    // if (window.attachSentry) {
    //   // console.log('** Attaching Sentry errorhandler');
    //   let newScript = document.createElement("script");
    //   newScript.setAttribute("type", "text/javascript");
    //   newScript.onload = () => {
    //       // console.log('** Sentry Script loaded');
    //       Sentry.init({
    //         dsn: 'https://8e78e17c8ae64a5aa37bfc1beab47859@o442790.ingest.sentry.io/5415367',
    //         integrations: [
    //           new Integrations.BrowserTracing(),
    //         ],
    //         tracesSampleRate: 1.0,
    //       });
    //   };
    //   newScript.src = "https://browser.sentry-cdn.com/5.22.3/bundle.tracing.min.js";
    //   newScript.integrity = "sha384-HfEJlGrJtFM0B01Wt4sGzTbxWqLMcMeGAXCbyQyB+iK9BhnDmNAtIGovhekIQOa2";
    //   newScript.crossOrigin="anonymous"
    //   document.getElementsByTagName("body")[0].appendChild(newScript);
    // }
    pageList.push({
        pageLocation: 'testerror323',
        image: function () { },
        pageTitle: 'Test Error',
        content: errorPage,
        subMenu: []
    });
    // TODO: Incude a pathPriority field so the order of potential double matches is fixed.
    // If the path name contains segments (e.g. /page/:id) transform the path into a regex (e.g. /^\/path\/(.*)(\/)?)
    // Also, create a pathVariables field which contains the segment names as keys.
    // Include a test for this to ensure path matching is working
    pageList = pageList.map(function (p) {
        if (p.pageLocation instanceof RegExp) {
            return p;
        }
        var splitPath = p.pageLocation.split('/');
        if (splitPath.filter(function (p) { return p.match(/^\:/); }).length > 0) {
            var vars = splitPath.map(function (p) { return p.match(/^\:/) ? p.substring(1) : null; }).filter(function (p) { return p; });
            p.pageLocation = new RegExp('^\\/' + splitPath.map(function (p) { return p.match(/^\:/) ? '(.*)' : p; }).join('/') + '(\\/)?');
            p.pathVariables = vars.reduce(function (a, b) { return (a[b] = undefined, a); }, {});
            return p;
        }
        return p;
    });
    exportedSiteData = __assign({}, siteData);
    addPolyfills();
    // Multiple components observe for page changes
    // Subscribers will be notified when the page changes and given the new page from pageList
    // The observavble will be passed as a parameter to those components which need it
    // Make pageChangeObservable an observable
    var pageChangeObservable = pageChangeSubject.asObservable()
        .pipe(
    // tap(p => console.log(`Before filter: ${p}`)),
    // tap(p => console.log(`>${window.location.pathname}< >${p}<`)),
    // tap(page => {
    //     console.log(`PCOb1 ${window.location.pathname} ${page}`);
    //     }),
    // filter(page => (window.location.pathname !== page)),
    // tap(page => {
    //     console.log(`PCOb ${window.location.pathname} ${page}`);
    //     }),
    map(function (newPage) {
        if (newPage) {
            return newPage;
        }
        return { page: window.location.pathname + window.location.hash, previousLocation: { pathname: 'changed' } };
    }), // Passing null as the page forces a rendering of the currect path (initial view)
    // tap(page => {
    //     console.log('pushing history')
    //     history.pushState({}, '', page.toString())
    // }),
    // tap(p => {
    //     console.log(`After filter: ${p}`);
    //     // debugger;
    // }),
    map(function (_a) {
        // let urlPath = page.location.split('/').filter(p => p.length > 0);
        var page = _a.page, previousLocation = _a.previousLocation;
        var anchor;
        var newPage = page;
        if (page.indexOf('#') > 0) {
            anchor = page.substring(page.indexOf('#') + 1);
            newPage = page.substring(0, page.indexOf('#'));
        }
        var foundPage = pageList.find(function (p) {
            if (p.pageLocation instanceof RegExp) {
                return p.pageLocation.test(newPage);
            }
            return (!p.hide && ('/' + p.pageLocation === newPage));
        })
            || pageList.find(function (p) { return p.pageLocation === 'notfound'; });
        return __assign(__assign({}, foundPage), { anchor: anchor, pageBaseChanged: newPage.valueOf() != previousLocation.pathname.valueOf() });
    }), 
    //TODO: Make work with multiple path variables and query parameters
    map(function (page) {
        if (page.pageLocation instanceof RegExp) {
            var matches_1 = page.pageLocation.exec(window.location.pathname);
            if (matches_1 && page.pathVariables) {
                Object.keys(page.pathVariables).map(function (k, i) {
                    page.pathVariables[k] = matches_1[i + 1];
                });
            }
        }
        return page;
    }), 
    // tap(p => console.log(`Before share: ${p}`)),
    share() // Only run the piped operators once for all subscribers
    );
    getStorePix(siteData.assetBase, siteData.fullpixlist); // Needs promise
    // const CustomisedFooter = () => footer(FooterContacts, FooterAddress, FooterSiteLogo);
    // const wide = document.body.clientWidth>1023;
    // const DM = wide ? DropMenu(DropMenuContent) : SideMenu(SideMenuContent); 
    // ScrollMenu(pageChangeObservable, HeadMenuContent, HeaderSiteLogo, DM);  // Once installed, the scroll menu handles itself
    // const footerWrapper = document.getElementById('footerwrapper') as HTMLElement;
    // // TODO: Delay until after page rendered
    // patch(footerWrapper, CustomisedFooter);
    // HeadMenu(pageChangeObservable, HeadMenuContent, HeaderSiteLogo, undefined);
    ImageBanner(pageChangeObservable);
    var gaPreQueue = [['create', siteData.ga, 'auto']];
    var addGaQueue = function (d) {
        if (siteData.ga !== null) {
            if (gaPreQueue.length > 0) {
                gaPreQueue.push(d);
            }
            else {
                window.ga.apply(window, d);
            }
        }
    };
    window.ga = function () {
    };
    window.ga.q = [];
    window.ga.l = +new Date;
    pageChangeObservable.subscribe({
        next: function (pageSelected) {
            var mainContainer = document.getElementById('pagewrapper');
            if (mainContainer !== null) {
                patch(mainContainer, function patchSimplePages() {
                    var content = pageSelected.content, pageTitle = pageSelected.pageTitle, name = pageSelected.name, index = pageSelected.index, pathVariables = pageSelected.pathVariables;
                    // content is a function so it gets executed during the rendering of the tree
                    createElement("render", null,
                        createElement("div", { class: "page-standard", id: "page-" + name }, function () { return pathVariables ? content(pageChangeObservable, pathVariables) : content(pageChangeObservable); }));
                    document.title = pageTitle.length > 0 ? siteData.pageTitleBase + " | " + pageTitle : siteData.pageTitleBase;
                    var indexPage = (index === undefined) ? true : index;
                    var mtags = document.getElementsByTagName("meta");
                    Array.prototype.forEach.call(mtags, function (t) {
                        if (t.name === 'robots') {
                            if (siteData.index && indexPage) { // but not undefined
                                t.setAttribute('content', 'index, follow, noarchive');
                                // console.log(`Page marked for index.`);
                            }
                            else {
                                t.setAttribute('content', 'noindex, follow, noarchive');
                                // console.log(`Page marked for no index.`);
                            }
                        }
                        ;
                    }); // There should always be a robots meta tag
                });
                // FIXME: Code not tested with anchors after bugfix
                if (pageSelected.anchor) {
                    var ael_1 = document.getElementById(pageSelected.anchor);
                    if (ael_1) {
                        setTimeout(function () {
                            var box = ael_1.getBoundingClientRect();
                            window.scrollTo(0, document.documentElement.scrollTop + box.top - 100);
                        }, 300); // FIXME: position changes if page lazy loads
                    }
                    else {
                        // console.log('anchor element not yet drawn')
                    }
                    // Feb 22: Not sure why pushstate was included here.  It is already in RXJS.  Both stops the back button working
                    // history.pushState(null, window.location.pathname+window.location.hash);
                }
                else {
                    // history.pushState(null, window.location.pathname);
                    window.scrollTo(0, 0);
                }
            }
            addGaQueue(['send', {
                    hitType: 'pageview',
                    page: window.location.pathname
                }]);
        }
    });
    // This causes the page to scroll to the top just before it is reloaded. 
    // Without this, Chrome will scroll the new page back down after loading.
    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    };
    // Force load images (put in rxjs)
    // getStorePix('banners/contact');
    cookie();
    // triggerPageChange(null);
    // TODO: Deply until render complete
    // NICE: Better search parameter parsing
    var gauser = /gauser=([^&#]*)/.exec(location.search);
    if (gauser !== null) {
        if ((gauser[1] === 'user') || (gauser[1].length === 0)) {
            document.cookie = "appzuka_ga_user=user;expires=Thu, 01-Jan-70 00:00:01 GMT;path=/";
            addGaQueue(['set', 'dimension1', 'user']);
        }
        else {
            var d = new Date();
            d.setTime(d.getTime() + (18 * 365 * 24 * 60 * 60 * 1000));
            document.cookie = "appzuka_ga_user=" + gauser[1] + ";expires=" + d.toUTCString() + ";path=/";
            addGaQueue(['set', 'dimension1', gauser[1]]);
        }
    }
    else {
        var getCook = function (cookiename) {
            var cookiestring = RegExp("" + cookiename + "[^;]+").exec(document.cookie);
            return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
        };
        var gauser_1 = getCook('appzuka_ga_user');
        addGaQueue(['set', 'dimension1', gauser_1.length === 0 ? 'user' : gauser_1]);
    }
    // The initial call to GA can be longer than 50ms and cause Lighthouse to report that the site
    // is non-interactive.  Delay the call for 5000ms and then space out the subsequent calls
    // to clear the queue by 200ms.
    if (siteData.ga !== null) {
        setTimeout(function () {
            var newScript = document.createElement("script");
            newScript.setAttribute("type", "text/javascript");
            newScript.onload = function () {
                var pushDelay = function (delayTime) {
                    var d = gaPreQueue[0];
                    setTimeout(function () {
                        // performance.mark('startga');
                        window.ga.apply(window, d);
                        // performance.measure('ga', 'startga');
                        gaPreQueue = gaPreQueue.slice(1);
                        if (gaPreQueue.length > 0) {
                            pushDelay(200);
                        }
                    }, delayTime);
                };
                pushDelay(500);
            };
            newScript.src = 'https://www.google-analytics.com/analytics.js';
            document.getElementsByTagName('body')[0].appendChild(newScript);
        }, 5000);
    }
    return pageChangeObservable;
};
export { initApp, packageVersion };
//# sourceMappingURL=initApp.js.map